import { render, staticRenderFns } from "./ElectedList.vue?vue&type=template&id=412d36f4&scoped=true"
import script from "./ElectedList.vue?vue&type=script&lang=js"
export * from "./ElectedList.vue?vue&type=script&lang=js"
import style0 from "./ElectedList.vue?vue&type=style&index=0&id=412d36f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d36f4",
  null
  
)

export default component.exports